export default "__VITE_ASSET__Omi37Qhs__"